import platform from "platform";

const mod = () => {
  let globalOnLoad = 0;
  let globalXRLoad = 0;

  return {
    setGlobalOnLoad: (value) => {
      globalOnLoad = value;
    },
    getPlatform: () => {
      const label = `${platform.os.family}_${platform.os.version}_${platform.product}_${platform.name}`;
      return label;
    },
    getGlobalOnLoad: () => {
      return globalOnLoad;
    },
    setGlobalXRLoad: (value) => {
      globalXRLoad = value;
    },
    getGlobalXRLoad: () => {
      return globalXRLoad;
    },
  };
};
const MainStateStore = mod();

export default MainStateStore;
